import React from "react";
import { Alert } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const MOBILE_ONLY_AD_BANNER =
  "This advertisement appears in the mobile app for members of your connected clubs. It does not appear on club websites.";

export const getAdDeliveryLabel = (delivery) => {
  if (delivery === "mobile_only") return "Mobile app";
  if (delivery === "website") return "Website";
  if (!delivery) return "Mobile app";
  return String(delivery).replace(/_/g, " ");
};

export const MobileOnlyAdBanner = ({ sx }) => (
  <Alert
    severity="info"
    icon={<InfoOutlinedIcon fontSize="inherit" />}
    sx={{ mb: 3, borderRadius: "12px", ...sx }}
  >
    {MOBILE_ONLY_AD_BANNER}
  </Alert>
);
